module.exports = __webpack_public_path__ + "static/img/bg-es.d56cc133.png";